export const lastUpdated = "29 Desember 2024";
